import { DivProps } from 'typings';

import transparentBackground from 'ud-ui/components/images/transparent-background.jpg';
import UDText from 'ud-ui/components/text';
import { BackgroundItemContainer, ColorBlock, ColorIcon, Image, ImageBlock } from './styles';
import { theme } from 'styles/theme/theme';

type IProps = DivProps & {
  color: string;
  colorName: string;
  img?: string;
  isActive?: boolean;
  className?: string;
};

function BackgroundItem(props: IProps) {
  const { color, colorName, img, isActive, className, ...rest } = props;
  return (
    <BackgroundItemContainer isActive={isActive} className={className} {...rest}>
      <ImageBlock
        color={color === 'transparent' ? undefined : color}
        imgUrl={color === 'transparent' ? (transparentBackground as string) : undefined}
      >
        {img && <Image alt={'лого'} src={img} />}
      </ImageBlock>
      <ColorBlock>
        <ColorIcon
          color={color === 'transparent' ? undefined : color}
          imgUrl={color === 'transparent' ? transparentBackground : undefined}
        />
        <UDText type={'tip'} style={{ color: theme.colors.SurfaceRomanSilver30 }}>
          {colorName}
        </UDText>
      </ColorBlock>
    </BackgroundItemContainer>
  );
}

export default BackgroundItem;
